import logoDefender from '../../../../assets/images/logo-defender.svg'
import axios from 'axios'
import config from '../../../../config'
import BizinBackend from '../../../../helpers/bizin_helper'

export const exportGridToHTML = async (gridComponents, options = {}) => {
  const filename = options.filename || 'relatorio_dados.html';
  const title = options.title || 'Relatório de Dados';
  const includeFACss = options.includeFontAwesomeCss !== false;
  const faCssUrl = options.faCssUrl || 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css';
  const maxCellWidthPx = typeof options.maxCellWidthPx === 'number' ? options.maxCellWidthPx : 100;
  const reportCssUrl = options.reportCssUrl || (typeof window !== 'undefined' ? `${window.location.origin}/report-export.css` : '/report-export.css');
  const resolvedLogoUrl = options.logoUrl || (typeof window !== 'undefined' ? new URL(logoDefender, window.location.origin).href : logoDefender);
  const includeAppCss = options.includeAppCss !== false;
  const includeGoogleFontsCss = options.includeGoogleFontsCss !== false;
  const googleFontsUrl = options.googleFontsUrl || 'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap';
  const appCssLinks = includeAppCss && typeof window !== 'undefined'
    ? (() => {
        try {
          // Links externos
          const hrefs = Array.from(document.querySelectorAll('link[rel="stylesheet"]'))
            .map(l => l && l.href)
            .filter(Boolean);
          const unique = Array.from(new Set(hrefs));
          const linksStr = unique
            .map(href => {
              try { return new URL(href, window.location.origin).href; } catch { return href; }
            })
            .map(abs => `<link rel="stylesheet" href="${abs}" />`)
            .join('\n');

          // Estilos inline (ex.: style-loader em dev)
          const styleTags = Array.from(document.querySelectorAll('style'))
            .map(s => s && s.textContent)
            .filter(css => css && css.trim().length > 0);
          const inlineStr = styleTags.length ? `<style>\n${styleTags.join('\n\n')}\n</style>` : '';

          return `${linksStr}\n${inlineStr}`;
        } catch (_) { return ''; }
      })()
    : '';

  // Código da transação (fallback: options.transactionCode)
  let transactionCode = options.transactionCode || '';
  try {
    const headChildren = gridComponents?.HEAD?.[0]?.Childrens || gridComponents?.HEAD?.[0]?.Childrens;
    const codeNode = Array.isArray(headChildren)
      ? headChildren.find((c) => c.Chave_Transacao_Componente === 'CODIGO_TRANSACAO' || c.Chave_Transacao_Componente === 'Codigo_Transacao')
      : null;
    transactionCode = codeNode?.Valor_Componente || transactionCode;
  } catch (_) {}


  console.log('gridComponents', gridComponents);
  
  const tableComponent = gridComponents?.BODY[0]?.Childrens?.find(
    (c) => c.Chave_Transacao_Componente === 'TABELA_RESULTADOS_GRID_001'
  );
  
  console.log('tableComponent', tableComponent);

  if (!tableComponent) throw new Error('Tabela não encontrada');

  // Usar dados filtrados se disponíveis, senão usar todos os dados
  let dataResult = [];
  if (options.filteredData && Array.isArray(options.filteredData)) {
    // Se há dados filtrados, usar eles (mesmo que seja array vazio após filtro)
    dataResult = options.filteredData;
  } else {
    // Se não há dados filtrados (primeira carga), usar dados originais
    try {
      dataResult = JSON.parse(
        tableComponent.Childrens.find(
          (c) => c.Chave_Transacao_Componente === 'PROCEDURE_RESULTSET'
        )?.Valor_Componente || '[]'
      ) || [];
    } catch (_) { dataResult = []; }
  }

  const columnsList = JSON.parse(
    tableComponent.Childrens.find(
      (c) => c.Chave_Transacao_Componente === 'TABELA_RESULTADOS_GRID_LISTA_COLUNAS'
    )?.Valor_Componente || '[]'
  );

  const exportColumns = columnsList.filter((col) =>
    (col.Export !== 'False' && col.Export !== false)
  );

  // Debug removido

  const escapeHtml = (str) => String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  // Extrai e sanitiza o primeiro <img> ou <i> válido de um HTML vindo do grid
  const extractFirstIconOrImageHtml = (html) => {
    try {
      if (typeof document === 'undefined') return '';
      // 1) Primeira tentativa: parse direto
      const container = document.createElement('div');
      container.innerHTML = String(html);
      let found = container.querySelector('img, i');
      // 2) Se não achou, pode estar escapado (&lt;...&gt;). Tentar decodificar e reparsear
      if (!found && /&lt;\/?(img|i)\b/i.test(String(html))) {
        const decodeWrap = document.createElement('div');
        decodeWrap.innerHTML = String(html);
        const decoded = decodeWrap.textContent || decodeWrap.innerText || '';
        const reparse = document.createElement('div');
        reparse.innerHTML = decoded;
        found = reparse.querySelector('img, i');
      }
      if (!found) return '';
      const tag = found.tagName.toLowerCase();
      if (tag === 'img') {
        const img = document.createElement('img');
        const src = found.getAttribute('src');
        if (!src) return '';
        img.setAttribute('src', src);
        const cls = found.getAttribute('class');
        if (cls) img.setAttribute('class', cls);
        const alt = found.getAttribute('alt') || '';
        if (alt) img.setAttribute('alt', alt);
        return img.outerHTML;
      }
      if (tag === 'i') {
        const iEl = document.createElement('i');
        const cls = found.getAttribute('class');
        if (cls) iEl.setAttribute('class', cls);
        const ariaHidden = found.getAttribute('aria-hidden');
        if (ariaHidden) iEl.setAttribute('aria-hidden', ariaHidden);
        return iEl.outerHTML;
      }
      return '';
    } catch (_) {
      return '';
    }
  };

  const renderCell = (value, col) => {
    if (value == null) return '';
    if (col.hasImage === 'True' || col.hasImage === true) {
      try {
        const parsed = typeof value === 'string' ? JSON.parse(value) : value;
        const arr = Array.isArray(parsed) ? parsed : [parsed];
        const colLabel = `${col?.header || ''} ${col?.field || ''}`.toLowerCase();
        const isAvatarColumn = /(foto|photo|avatar|usu[aá]rio|user|perfil|face|imagem.*pessoa)/.test(colLabel);
        const isValidImageSrc = (src) => {
          if (!src && src !== 0) return false;
          const s = String(src).trim();
          if (!s || s === '[]' || s === '{}' || s.toLowerCase() === 'null' || s.toLowerCase() === 'undefined') return false;
          if (s.startsWith('data:image')) return true;
          if (/^https?:\/\//i.test(s)) return true;
          if (/^\//.test(s)) return true; // caminho absoluto
          return false;
        };
        const parts = arr.map((it) => {
          // objeto imagem estruturado
          if (it && typeof it === 'object' && it.tipo === 'image') {
            const src = it?.valor;
            if (isValidImageSrc(src)) {
              const cls = isAvatarColumn ? 'img-avatar' : 'img-inline';
              return `<img src="${escapeHtml(src)}" class="${cls}"/>`;
            }
            return '';
          }
          // objeto ícone
          if (it && typeof it === 'object' && it.tipo === 'icone' && it?.valor) {
            return `<i class="${escapeHtml(it.valor)}"></i>`;
          }
          // objeto texto
          if (it && typeof it === 'object' && it.tipo === 'texto' && it?.valor != null && it.valor !== '') {
            return `<span class="text-inline">${escapeHtml(String(it.valor))}</span>`;
          }
          // string HTML contendo <img> ou <i> (frequente em alguns relatórios)
          if (typeof it === 'string' && (/[<](img|i)\b/i.test(it) || /d-flex|user-photo-label|fa-user-circle/i.test(it))) {
            const normalized = extractFirstIconOrImageHtml(it);
            if (normalized) return normalized;
          }
          // string direta contendo URL/DataURL
          if (typeof it === 'string' && isValidImageSrc(it)) {
            const cls = isAvatarColumn ? 'img-avatar' : 'img-inline';
            return `<img src="${escapeHtml(it)}" class="${cls}"/>`;
          }
          return '';
        });
        const joined = parts.join('');
        if (joined && joined.trim().length > 0) {
          return `<span class="icon-cell">${joined}</span>`;
        }
        // Fallback padrão para qualquer coluna com imagem/ícone ausente
        return `<span class="icon-cell"><i class="far fa-user-circle font-size-32 user-photo-label" aria-hidden="true"></i></span>`;
      } catch (_) {
        // Se o valor não é JSON e veio como HTML com <img>/<i>, tentar extrair
        if (typeof value === 'string' && (/[<](img|i)\b/i.test(value) || /d-flex|user-photo-label|fa-user-circle/i.test(value))) {
          const normalized = extractFirstIconOrImageHtml(value);
          if (normalized) {
            return `<span class="icon-cell">${normalized}</span>`;
          }
        }
        // Fallback padrão mesmo em erro de parse
        return `<span class="icon-cell"><i class="far fa-user-circle font-size-32 user-photo-label" aria-hidden="true"></i></span>`;
      }
    }
    const str = typeof value === 'string' ? value : String(value);
    const cleaned = str.replace(/[^\x20-\x7E\n\r\t]/g, '');
    const trimmed = cleaned.trim();
    // Se vier HTML do grid contendo img/ícone, extrair e normalizar
    if (/[<](img|i)\b/i.test(trimmed) || /d-flex|user-photo-label|fa-user-circle/i.test(trimmed)) {
      const normalized = extractFirstIconOrImageHtml(trimmed);
      if (normalized) {
        return `<span class="icon-cell">${normalized}</span>`;
      }
    }
    // Se parece um e-mail (tem '@' e sem espaços), não quebrar linha
    const looksLikeEmail = trimmed.includes('@') && !/\s/.test(trimmed);
    if (looksLikeEmail) {
      return `<span class="nowrap">${escapeHtml(cleaned)}</span>`;
    }
    return escapeHtml(cleaned);
  };

  // Tenta obter rótulos dinâmicos a partir de options ou do contexto do grid
  const getAttributeValueByKey = (gc, key) => {
    try {
      const fromHead = gc?.HEAD?.[0]?.Childrens?.find?.((c) => c.Chave_Transacao_Componente === key)?.Valor_Componente;
      if (fromHead != null) return fromHead;
      const fromBody = gc?.BODY?.[0]?.Childrens?.find?.((c) => c.Chave_Transacao_Componente === key)?.Valor_Componente;
      if (fromBody != null) return fromBody;
      return null;
    } catch (_) { return null; }
  };
  const contextColumnsRaw = getAttributeValueByKey(gridComponents, 'CONTEXTO_LISTA_COLUNAS');
  let contextColumns = [];
  try { contextColumns = JSON.parse(contextColumnsRaw || '[]'); } catch (_) { contextColumns = []; }
  const contextUserNameHeader = Array.isArray(contextColumns)
    ? (contextColumns.find((c) => c.field === 'Nome_Completo')?.header || '')
    : '';
  const contextDepartmentHeader = Array.isArray(contextColumns)
    ? (contextColumns.find((c) => c.field === 'Departamento')?.header || '')
    : '';
  const contextRoleHeader = Array.isArray(contextColumns)
    ? (contextColumns.find((c) => c.field === 'Cargo')?.header || '')
    : '';
  const userNameLabel = options?.labels?.userNameLabel || contextUserNameHeader || 'Nome do Usuário';
  const departmentLabel = options?.labels?.departmentLabel || contextDepartmentHeader || 'Departamento';
  const roleLabel = options?.labels?.roleLabel || contextRoleHeader || 'Cargo';

  const headers = exportColumns.map((c) => {
    const w = typeof c.width === 'number' ? `${c.width}px` : c.width;
    const widthStyle = w ? ` style="width: ${w}; max-width: ${w}; --cell-max-width: ${w};"` : '';
    return `<th${widthStyle}>${escapeHtml(c.header)}</th>`;
  }).join('');
  const rows = dataResult.map((row) => {
    const tds = exportColumns.map((col) => {
      const content = renderCell(row[col.field], col);
      const tdClass = 'cell';
      const w = typeof col.width === 'number' ? `${col.width}px` : col.width;
      const widthStyle = w ? ` style="width: ${w}; max-width: ${w}; --cell-max-width: ${w};"` : '';
      return `<td class="${tdClass}"${widthStyle}>${content}</td>`;
    }).join('');
    return `<tr>${tds}</tr>`;
  }).join('\n');

  // Cabeçalho e rodapé com tarja azul
  const headerFooterHtml = `
    <div class="defender-header">
      <div class="defender-logo">
        <img src="${escapeHtml(resolvedLogoUrl)}" alt="Defender" class="defender-logo-img"/>
      </div>
      <div class="report-title">${escapeHtml(title)}</div>
    </div>
  `;

  // Construção dos chips de filtros
  const buildFilterPills = (applied) => {
    if (!applied || !applied[0] || Object.keys(applied[0]).length === 0) return [];
    const pills = [];
    const filterObj = applied[0];
    Object.keys(filterObj).forEach((key) => {
      const filter = filterObj[key];
      if (Array.isArray(filter)) {
        if (filter[0]?.values && filter[0]?.field) {
          filter[0].values.forEach((v) => pills.push(String(v.label || v.value)));
        }
      } else if (filter && typeof filter === 'object') {
        const value = filter.label || filter.value;
        if (value) pills.push(String(value));
      }
    });
    return pills;
  };

  const filterPills = buildFilterPills(options.appliedFilters);

  const filtersBarHtml = `
    <div class="filters-bar">
      <div class="filters-left">
        ${filterPills.length > 0 ? `
        <span class="filters-title">Filtros aplicados:</span>        
        <span class="filter-list">${filterPills.map(p => `<span class="filter-pill">${escapeHtml(p)}</span>`).join('')}</span>
        ` : ''}
      </div>
      <div class="code-display"><b>Código:</b> ${escapeHtml(transactionCode || '')}</div>
    </div>
  `;

  // Dados do usuário logado (nome, cargo, departamento, foto)
  const getSafe = (obj, keys, fallback = '') => {
    try {
      return keys.reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : null), obj) ?? fallback;
    } catch (_) { return fallback; }
  };
  const parseFoto = (foto) => {
    if (!foto) return null;
    if (typeof foto === 'string') {
      if (foto.startsWith('data:image') || foto.startsWith('http')) return foto;
      try {
        const parsed = JSON.parse(foto);
        if (Array.isArray(parsed) && parsed[0]?.valor) return parsed[0].valor;
      } catch (_) {}
    }
    return null;
  };
  let userInfo = options.userInfo || null;
  if (!userInfo && typeof window !== 'undefined') {
    try {
      const raw = window.localStorage.getItem('authUser');
      const obj = raw ? JSON.parse(raw) : {};
      const profile = getSafe(obj, ['resultset_2', 0]) || getSafe(obj, ['resultset_1', 0]) || obj;
      userInfo = {
        nome: profile.Nome_Completo || profile.Nome_Usuario || profile.Apelido || '',
        cargo: profile.Cargo || '',
        departamento: profile.Departamento || '',
        foto: parseFoto(profile.Foto_Usuario) || profile.Foto_Usuario || null,
      };
    } catch (_) {}
  }
  const collectContextCompanyLogos = () => {
    try {
      if (typeof document === 'undefined') return [];
      // Coleta imagens da caixa de contexto (empresa) exibidas na tela
      const nodeList = document.querySelectorAll('.card-context-dynamic .img-card');
      const srcs = Array.from(nodeList)
        .map((img) => img && img.getAttribute && img.getAttribute('src'))
        .filter((s) => typeof s === 'string' && s.trim().length > 0);
      return Array.from(new Set(srcs));
    } catch (_) { return []; }
  };
  const companiesLogos = Array.isArray(options.userCompaniesLogos) ? options.userCompaniesLogos : collectContextCompanyLogos();
  const companiesHtml = companiesLogos.map((logo) => `<img src="${escapeHtml(String(logo))}" class="company-logo" alt="Empresa"/>`).join('');

  // Mostra o box de info do usuário apenas se existir CONTEXTO_001 no HEADER da transação
  const hasUserContext = (() => {
    try {
      const headerChildren = gridComponents?.HEADER?.[0]?.Childrens;
      if (!Array.isArray(headerChildren)) return false;
      return headerChildren.some((c) => c?.Chave_Transacao_Componente === 'CONTEXTO_001');
    } catch (_) { return false; }
  })();

  const userInfoHtml = hasUserContext ? `
    <div class="user-info-grid">
      <div class="user-col user-name">
        <div class="user-avatar">${userInfo?.foto ? `<img src="${escapeHtml(userInfo.foto)}" class="user-avatar-img" alt="${escapeHtml(userInfo?.nome || 'Usuário')}"/>` : `<i class="far fa-user-circle"></i>`}</div>
        <div class="user-name-info">
          <div class="user-label">${escapeHtml(userNameLabel)}</div>
          <div class="user-value">${escapeHtml(userInfo?.nome || '')}</div>
        </div>
      </div>
      <div class="user-col">
        <div class="user-label">${escapeHtml(departmentLabel)}</div>
        <div class="user-value">${escapeHtml(userInfo?.departamento || '')}</div>
      </div>
      <div class="user-col">
        <div class="user-label">${escapeHtml(roleLabel)}</div>
        <div class="user-value">${escapeHtml(userInfo?.cargo || '')}</div>
      </div>
      <div class="user-col">
        <div class="user-label">Empresas</div>
        <div class="user-value companies">${companiesHtml}</div>
      </div>
    </div>
  ` : '';

  // Totalizadores e rodapé
  const findTotalsInComponents = (root) => {
    const totals = [];
    try {
      const stack = Array.isArray(root) ? [...root] : [root];
      while (stack.length) {
        const node = stack.pop();
        if (!node || typeof node !== 'object') continue;
        if (Array.isArray(node)) {
          node.forEach((n) => stack.push(n));
          continue;
        }
        // Verifica atributos do nó atual
        if (node.Chave_Transacao_Componente === 'PROCEDURE_RESULTSET' && typeof node.Valor_Componente === 'string') {
          try {
            const parsed = JSON.parse(node.Valor_Componente || '[]');
            if (Array.isArray(parsed) && parsed.length > 0) {
              const first = parsed[0];
              const hasTotalsShape = first && typeof first === 'object' && 'Nome_Totalizador' in first && 'Valor_Totalizador' in first;
              if (hasTotalsShape) {
                parsed.forEach((it) => {
                  if (it && typeof it === 'object' && it.Nome_Totalizador != null && it.Valor_Totalizador != null) {
                    totals.push({
                      Nome_Totalizador: String(it.Nome_Totalizador),
                      Valor_Totalizador: String(it.Valor_Totalizador),
                    });
                  }
                });
              }
            }
          } catch (_) {}
        }
        // Percorre filhos
        if (node.Childrens) stack.push(node.Childrens);
        if (node.HEAD) stack.push(node.HEAD);
        if (node.BODY) stack.push(node.BODY);
      }
    } catch (_) {}
    return totals;
  };

  const totalsItems = findTotalsInComponents(gridComponents);
  const totalsBodyHtml = totalsItems.length > 0
    ? totalsItems.map((t) => `<div class="totals-body">${escapeHtml(t.Nome_Totalizador)} <b>${escapeHtml(t.Valor_Totalizador)}</b></div>`).join('')
    : `<div class="totals-body">registros <b>${dataResult.length}</b></div>`;

  const totalsBarHtml = `
    <div class="totals-bar">
      <div class="totals-chip">Totalizadores</div>
      ${totalsBodyHtml}
    </div>
  `;
  const formatNowBr = () => {
    try {
      const d = new Date();
      const pad = (n) => String(n).padStart(2, '0');
      const dia = pad(d.getDate());
      const mes = pad(d.getMonth() + 1);
      const ano = d.getFullYear();
      const hora = pad(d.getHours());
      const min = pad(d.getMinutes());
      return `${dia}/${mes}/${ano} ${hora}:${min}`;
    } catch (_) { return ''; }
  };
  const footerHtml = `
    <div class="defender-footer">
      <div class="footer-left">Emitido por: <span> ${escapeHtml(userInfo?.nome || '')} às ${formatNowBr()} </span> </div>
      <div class="footer-right"></div>
    </div>
  `;

  const html = `<!DOCTYPE html>
<html lang="pt-BR">
<head>
  <meta charset="utf-8" />
  <title>${escapeHtml(title)}</title>
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <style>
    :root{--cell-max-width: ${maxCellWidthPx}px;} 
    html, body{font-family: "Poppins", sans-serif;} 
    td.cell{padding-top:10px;padding-bottom:10px;}
    .icon-cell {
      display: flex !important;
      flex-direction: row !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 8px !important;
          width: 60px !important;
    }
    .icon-cell i {
      display: inline-block !important;
    }
  </style>
  <link rel="stylesheet" href="${reportCssUrl}" />
  ${includeGoogleFontsCss ? `<link rel="stylesheet" href="${googleFontsUrl}" />` : ''}
  ${includeFACss ? `<link rel="stylesheet" href="${faCssUrl}" crossorigin="anonymous" referrerpolicy="no-referrer" />` : ''}
  ${appCssLinks}
  </head>
<body>
  ${headerFooterHtml}
  ${filtersBarHtml}
  ${userInfoHtml}
  <div class="main-content">
    
    <table>
      <thead><tr>${headers}</tr></thead>
      <tbody>
        ${rows}
      </tbody>
    </table>
  </div>
  ${totalsBarHtml}
  ${footerHtml}
</body>
</html>`;

  // Se convertToPdf for false, retornar HTML diretamente
  const convertToPdf = options.convertToPdf !== false // default é true para manter compatibilidade
  
  if (!convertToPdf) {
    // Fazer download do HTML diretamente
    const blob = new Blob([html], { type: 'text/html;charset=utf-8;' })
    const link = document.createElement('a')
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute('download', filename)
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
    return
  }

  // Gerar PDF via API
  try {
    // Obter CSRF token
    let csrfToken
    try {
      const csrfResponse = await BizinBackend.getCsrfToken()
      csrfToken = csrfResponse?.csrfToken || csrfResponse
    } catch (error) {
      const response = await axios.get(`${config.URL_SERVER}/_get_csrf_token`, {
        headers: { 'Origin': window.location.origin }
      })
      csrfToken = response.data?.csrfToken
    }

    if (!csrfToken) {
      throw new Error('Não foi possível obter CSRF token')
    }

    // Salvar HTML temporariamente
    const saveResponse = await axios.post(
      `${config.URL_SERVER}/salvar-html-temporario`,
      { html },
      {
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        timeout: 30000
      }
    )
    
    const tempUrl = saveResponse.data.url
    
    const response = await axios.post(
      `${config.URL_SERVER}/gerar-pdf`,
      { 
        parameters: {
          url: tempUrl
        }
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        responseType: 'blob',
        timeout: 180000
      }
    )

    // Verificar se recebeu PDF válido
    const contentType = response.headers['content-type'] || response.headers['Content-Type']
    
    // Verificar se é PDF pelo Content-Type
    const isPdfContentType = contentType === 'application/pdf' || contentType?.includes('pdf')
    
    const hasData = response.data instanceof Blob && response.data.size > 0
    
    let hasPdfSignature = false
    if (response.data instanceof Blob) {
      const firstBytes = await response.data.slice(0, 4).text()
      hasPdfSignature = firstBytes.startsWith('%PDF')
    }
    
    const isPdf = isPdfContentType && hasData && hasPdfSignature
    
    if (response.data && isPdf) {
      const pdfBlob = response.data instanceof Blob 
        ? response.data 
        : new Blob([response.data], { type: 'application/pdf' })
      
      const link = document.createElement('a')
      const url = URL.createObjectURL(pdfBlob)
      const pdfFilename = filename.endsWith('.pdf') ? filename : filename.replace(/\.html?$/, '.pdf')
      link.setAttribute('href', url)
      link.setAttribute('download', pdfFilename)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    } else {
      throw new Error(`Resposta da API não é um PDF válido. Content-Type: ${contentType}, Status: ${response.status}`)
    }
  } catch (error) {
    throw new Error(`Erro ao gerar PDF: ${error.message}`)
  }
};

export default exportGridToHTML


